import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form';

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';

import Loader from "../../Loader/Loader.jsx";
import ExpertiseTypeahead from "../../Form/Field/ExpertiseTypeahead.jsx";
import Input from "../../Form/Field/Input.jsx";
import FunctionTypeahead from "../../Form/Field/FonctionTypeahead.jsx";

export const name = 'FreelanceInterviewSkillsForm';

class FreelanceInterviewSkillsForm extends PureComponent {
  render() {
    return <div id={name}>
      <form autoComplete="off" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="col-lg-6">
            <Field
              label="Titre de votre fiche"
              placeholder={this.props?.currentUniverse?.title_placeholder ?? ''}
              name="freelance.title"
              type="text"
              component={Input}
              customOnBlur={this.props.handleSubmit}
            />
          </div>
          <div className="col-lg-6">
            <Field
              label="Métiers/Fonctions exercées"
              name="freelance.fonctions"
              placeholder={this.props?.currentUniverse?.fonctions_placeholder ?? ''}
              component={FunctionTypeahead}
              customOnChange={this.props.handleSubmit}
            />
          </div>
          <div className="col-lg-6">
            <Field
              label="Compétences - Mes spécialités (8 max)"
              name="freelance.master_skills"
              placeholder={this.props?.currentUniverse?.master_skills_placeholder ?? ''}
              component={ExpertiseTypeahead}
              customOnChange={this.props.handleSubmit}
            />
          </div>
          <div className="col-lg-6">
            <Field
              label="Compétences - Niveau Confirmé (10 max)"
              name="freelance.expertises"
              placeholder={this.props?.currentUniverse?.expertises_placeholder ?? ''}
              component={ExpertiseTypeahead}
              customOnChange={this.props.handleSubmit}
            />
          </div>
        </div>
        <input className="d-none" type="submit"/>
        <FormGlobalErrors className="mt-0" errors={this.props.error}/>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </div>;
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name)
})(FreelanceInterviewSkillsForm);
